<dialog #dlg class="tw-dialog" (click)="onBackdropClick($event)" (cancel)="onCancel($event)">
  <div class="tw-dialog__panel">
    <app-sidebar-nav></app-sidebar-nav>
  </div>
</dialog>
